<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <new-barman></new-barman>
      </div>
    </div>
  </div>
</template>

<script>
  import NewBarman from '../components/Users/NewBarman';

  export default {
    components: {
      NewBarman
    }
  }

</script>

<style>

</style>
